var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,8.1C66.6-2.3,45.3-2.7,28.1,7s-28,28-28,47.9v402.2c0,19.9,10.7,38.2,28,47.9c17.3,9.7,38.5,9.3,55.4-1l329.1-201.1 c16.3-9.9,26.3-27.7,26.3-46.8s-9.9-36.8-26.3-46.8L83.5,8.1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play.131efa4e155a6893b517c1c4df3356b2.svg";